import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { tabbable } from 'tabbable';
var TAB_KEY = 9;

function getNextActiveElement(node, startNode) {
  if (startNode === void 0) {
    startNode = null;
  }

  var tabbables = tabbable(node.parentNode);
  var nodeToStartAt = startNode || node;
  var nextTabbable = tabbables[tabbables.indexOf(nodeToStartAt) + 1];

  if (!nextTabbable && node !== document.body) {
    return getNextActiveElement(node.parentNode, nodeToStartAt);
  }

  return nextTabbable;
}

var RewireTabOrder = /*#__PURE__*/function () {
  function RewireTabOrder(node) {
    var _this = this;

    _defineProperty(this, "tabbables", []);

    _defineProperty(this, "firstFocusableElement", null);

    _defineProperty(this, "lastFocusableElement", null);

    _defineProperty(this, "originalActiveElement", null);

    _defineProperty(this, "nextActiveElement", null);

    _defineProperty(this, "focusOriginalActiveElement", function () {
      _this.originalActiveElement.focus();
    });

    _defineProperty(this, "focusNextActiveElement", function () {
      _this.nextActiveElement.focus();
    });

    _defineProperty(this, "moveFocusToTargetFromTriggerElement", function (event) {
      if (!event.shiftKey && event.keyCode === TAB_KEY) {
        event.preventDefault();

        _this.firstFocusableElement.focus();
      }
    });

    _defineProperty(this, "moveFocusFromTargetToTriggerElement", function (event) {
      if (event.target === _this.firstFocusableElement && event.shiftKey && event.keyCode === TAB_KEY) {
        event.preventDefault();

        _this.originalActiveElement.focus();
      }
    });

    _defineProperty(this, "moveFocusToTargetFromNextElement", function (event) {
      if (event.shiftKey && event.keyCode === TAB_KEY) {
        event.preventDefault();

        _this.lastFocusableElement.focus();
      }
    });

    _defineProperty(this, "moveFocusFromTargetToNextElement", function (event) {
      if (!event.shiftKey && event.keyCode === TAB_KEY) {
        event.preventDefault();

        _this.nextActiveElement.focus();
      }
    });

    if (node) {
      this.tabbables = tabbable(node);

      if (this.tabbables.length > 0) {
        this.init();
      }
    }
  }

  var _proto = RewireTabOrder.prototype;

  _proto.init = function init() {
    this.firstFocusableElement = this.tabbables[0];
    this.lastFocusableElement = this.tabbables[this.tabbables.length - 1];
    this.originalActiveElement = document.activeElement;
    this.nextActiveElement = getNextActiveElement(this.originalActiveElement);
    this.originalActiveElement.addEventListener('keydown', this.moveFocusToTargetFromTriggerElement);
    this.firstFocusableElement.addEventListener('keydown', this.moveFocusFromTargetToTriggerElement);

    if (this.nextActiveElement) {
      this.nextActiveElement.addEventListener('keydown', this.moveFocusToTargetFromNextElement);
      this.lastFocusableElement.addEventListener('keydown', this.moveFocusFromTargetToNextElement);
    }
  };

  _proto.destroy = function destroy() {
    if (this.tabbables.length === 0) {
      return;
    }

    this.originalActiveElement.removeEventListener('keydown', this.moveFocusToTargetFromTriggerElement);
    this.firstFocusableElement.removeEventListener('keydown', this.moveFocusFromTargetToTriggerElement);

    if (this.nextActiveElement) {
      this.nextActiveElement.removeEventListener('keydown', this.moveFocusToTargetFromNextElement);
      this.lastFocusableElement.removeEventListener('keydown', this.moveFocusFromTargetToNextElement);
    }
  };

  return RewireTabOrder;
}();

export default (function (node) {
  var unwireTabOrder = new RewireTabOrder(node);
  return function () {
    return unwireTabOrder.destroy();
  };
});